import {
  Link,
  useLocation,
  useMatch,
  useParams,
} from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import { GlobalContext } from "../context/Provider";
import henceforthApi from "../utils/henceforthApi";
import PaginationLayout from "../components/PaginationLayout";
import moment from "moment";
import profile_placeholder from "../assets/images/profile_placeholder.png";
import Button from "react-bootstrap/Button";
import Carousel from "react-bootstrap/Carousel";
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';
import Modal from "react-bootstrap/Modal";
import { getUserProfileImage } from "../utils/constant_value";

function ReportedStories() {
  const location = useLocation();
  const match = useMatch("/reported-stories/:page");
  const param = useParams();

  const newParam = new URLSearchParams(location.search);
  const {
    authState,
    staticDataState,
    handleError,
    scrollToTop,
    handlePagination, handleFilter
  } = useContext(GlobalContext);
  const nfts = staticDataState.nfts;

  henceforthApi.setToken(authState.access_token);
  //modal
  const [Reply, setReply] = useState(false);
  const handleCloseReply = () => setReply(false);
  const [Views, setViews] = useState(false);
  const handleCloseViews = () => setViews(false);
  const [manageMedias, setManageMedias] = useState({
    type: "",
    _id: "",
    admin_verified: false,
    language: "ENGLISH",
    account_status: "",
  });
  //FEtch
  const [storiesData, setStoriesData] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [loading, setLoading] = useState(false);
  let limit = 9;
  const fetchStories = async () => {
    try {
      setLoading(true)
      const StoriesRes = await henceforthApi.Reported.stories(
        "3",
        Number(param.page) - 1,
        limit,
        query.toString()
      );
      setStoriesData(StoriesRes.story);
      setTotalCount(StoriesRes.count);
      setLoading(false)
    } catch (error) {
      handleError(error)
    }

  };
  // const onChangePagination = (newVal) => {
  //   const newParam = new URLSearchParams(location.search);
  //   if (newParam.has("search")) {
  //     navigate(`/reported-stories/${newVal}?search=${newParam.get("search")}`);
  //   } else {
  //     navigate(`/reported-stories/${newVal}`);
  //   }
  // };

  const [photoIndex, setPhotoIndex] = useState(0)
  const [isOpen, setIsOpen] = useState(false)
  const [lightboxImages, setLightboxImages] = useState([])
  const initialiseLightBox = (data) => {
    setPhotoIndex(0)
    setIsOpen(true)
    setLightboxImages(data)
  }
  var query = new URLSearchParams(location.search);
  const filters = [
    { name: "Activated", value: "Active" },
    { name: "Deactivated", value: "Deactive" }
  ];
  // const onFilterApply = (name, value) => {
  //   if (query.has(name)) {
  //     let queryValue = query.get(name);
  //     // if (queryValue == value) {
  //     if (value === "") {
  //       query.delete(name);
  //     } else {
  //       query.set(name, value);
  //     }
  //   } else {
  //     query.set(name, value);
  //   }
  //   navigate({ pathname: `/reported-stories/1`, search: query.toString() }, { replace: true });
  // };
  //Remove
  const [showRemove, setShowRemove] = useState(false);
  const handleConfirm = (id) => {
    setShowRemove(id);
  }
  const handleRemove = async (id) => {
    try {
      await henceforthApi.Stories.delete(id);
      setShowRemove(false);
      fetchStories();
    } catch (Error) {
    }
    setShowRemove(false)
  };

  //View

  const [getView, setGetView] = useState([]);
  const handleView = async (_id) => {
    setViews(true);
    const viewResponse = await henceforthApi.Stories.view(_id);
    setGetView(viewResponse);
  };

  //Replies
  const [getReply, setGetReply] = useState([]);
  const handleReply = async (_id) => {
    setReply(true);
    const ReplyResponse = await henceforthApi.Stories.reply(_id);
    setGetReply(ReplyResponse);
  };

  useEffect(() => {
    scrollToTop();
    fetchStories();
  }, [param.page, newParam.get("search"), manageMedias, query.toString()]);

  return (
    <>
      <div class="row animated fadeInRight">
        <div class="col-md-12">
          <div>
            {isOpen && <Lightbox
              mainSrc={`${henceforthApi.API_FILE_ROOT_ORIGINAL}${lightboxImages[photoIndex].media_url}`}
              nextSrc={lightboxImages[(photoIndex + 1) % lightboxImages.length]}
              prevSrc={lightboxImages[(photoIndex + lightboxImages.length - 1) % lightboxImages.length]}
              onCloseRequest={() => setIsOpen(false)}
              onMovePrevRequest={() =>
                setPhotoIndex((photoIndex + lightboxImages.length - 1) % lightboxImages.length)
              }
              onMoveNextRequest={() =>
                setPhotoIndex((photoIndex + 1) % lightboxImages.length)
              }
            />}
          </div>
          <div className="ibox">
            <div className="ibox-title d-flex align-items-center justify-content-between">
              <h5 style={{ fontSize: "16px" }} className="m-0 fw-bold">
                List of all reported stories
              </h5>
              <div className="dropdown theme me-3">
                <button
                  className="btn dashboard-button pe-4 ps-4 dropdown-toggle shadow-none"
                  id="sortDropdown"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  {filters.filter((res) => res.value == query.get("filter"))
                    .length
                    ? filters.filter(
                      (res) => res.value === query.get("filter")
                    )[0].name
                    : "All"}
                  {/* <i
                className="fas fa-chevron-down bi-chevron-down ms-2 "
                style={{ fontSize: "12px" }}
              ></i> */}
                </button>
                <ul
                  className="dropdown-menu share-icons"
                  aria-labelledby="sortDropdown"
                >
                  {query.has("filter") && (
                    <li className="cursor-pointer">
                      <a
                        className="dropdown-item"
                        onClick={() => handleFilter("filter", "")}
                      >
                        All
                      </a>
                    </li>
                  )}
                  {filters.map((res) => {
                    return (
                      <li key={res.value} className="cursor-pointer">
                        <a
                          className="dropdown-item"
                          onClick={() => handleFilter("filter", res.value)}
                        >
                          {res.name}
                        </a>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>
            <div className="ibox-title d-flex align-items-center justify-content-between"></div>
            <div className="ibox-content">
              <div className="row">
                {!loading && !storiesData?.length ? <div className="text-center"> <b>No Stories Found </b> </div> : storiesData?.map((item, index) => (
                  <div class="col-md-4">
                    <div class="card mb-4 box-shadow border-0 shadow h-100">
                      <Link to="">
                        <div className="explore-img" key={index}>
                          <Carousel interval={null}>
                            {Array.isArray(item?.post_medias) &&
                              item?.post_medias.map((res, index) => (
                                <Carousel.Item key={index}>
                                  {res?.media_type == "IMAGE" ? (
                                    <img
                                      className="d-block w-100"
                                      src={`${henceforthApi.API_FILE_ROOT_ORIGINAL}${res.media_url}`}
                                      alt=""
                                      onClick={() => initialiseLightBox(item?.post_medias)}
                                      style={{ cursor: "pointer" }}
                                    />
                                  ) : (
                                    <video
                                      id="videos"
                                      class="video-bg"
                                      src={`https://shadowzapp.sgp1.digitaloceanspaces.com/shadowzapp/video/${res.media_url}`}
                                      autoPlay
                                      muted
                                    />
                                  )}
                                </Carousel.Item>
                              ))}
                          </Carousel>
                        </div>
                      </Link>
                      <div class="card-body">
                        <div className="username-box my-1 d-flex justify-content-between align-items-center">
                          <div className="d-flex gap-1 ProfileImagePRS-box">
                            <img className="ProfileImagePRS" src={getUserProfileImage(item?.profile_pic)} alt="" />
                            <Link
                              to={`/user/${item?.user_id}/1/1?type=posts`}
                              className="Details_of_User"
                            >
                              <p className="fw-bolder m-0" style={{ fontSize: "14px" }}>
                                {item?.name}
                              </p>
                            </Link >
                          </div>
                          <div>
                            <label className="PublicPrivate">
                              <i
                                class={item?.is_private == false ?
                                  `fas fa-globe-africa` : `fas fa-lock`}
                                style={{ marginRight: "3px" }}
                              ></i>
                              {item?.is_private == false
                                ? "Public"
                                : "Private"}
                            </label>
                          </div>
                        </div>
                        <div className="col-12">
                    <div className="text-end">
                        <label className={item.status == "Active" ? "custom-status" : "custom-status-deactivate"}>
                          {item.status}
                        </label>
                      </div>
                    </div>
                        <div className="both-added my-3">
                          <div className="">
                            <div className="fw-bolder">
                              <h6
                                onClick={() => handleView(item.post_id)}
                                style={{
                                  cursor: "pointer",
                                  fontSize: "14px",
                                }}
                              >
                                {" "}
                                Views:
                                <span
                                  style={{
                                    fontWeight: "bold",
                                    marginLeft: "3px",
                                  }}
                                >
                                  {item.views_count}
                                </span>
                              </h6>
                            </div>
                          </div>
                          <div className="brown-text text-wrap">
                            <div
                              onClick={() => handleReply(item.post_id)}
                              style={{ cursor: "pointer" }}
                              className="fw-bolder"
                            >
                              <h6 style={{ fontSize: "14px" }}>
                                {" "}
                                Comments:
                                <span
                                  style={{
                                    fontWeight: "bold",
                                    fontSize: "14px ",
                                    marginLeft: "3px",
                                  }}
                                >
                                  {item.replies_count}
                                </span>
                              </h6>
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div className="" style={{ fontSize: "16px" }}>
                          <h6
                            className="text-ellipse"
                            style={{ fontSize: "14px" }}
                          >
                            Report Reason :{" "}
                            <span
                              title={item?.reportedReason}
                              style={{ fontWeight: "bold" }}
                            >
                              {" "}
                              {item.report_reason}
                            </span>
                          </h6>
                          <h6 className="" style={{ fontSize: "14px" }}>
                            Reported By :
                            <span style={{ fontWeight: "bold" }}>
                              {" "}
                              
                              {item?.reported_by?.length ? item?.reported_by?.flat().slice(0, 3)?.map((res, index) => {
                                return (
                                  <span key={res?._id || index}>
                                    {res?.full_name}
                                    {index < Math.min(item?.reported_by?.flat().length, 3) - 1 && ", "}
                                  </span>
                                );
                              }) : ""}
                              {item?.reported_by?.flat().length > 3 && (
                                <b className="" style={{ cursor: "pointer" }}>
                                  ....view more
                                </b>
                              )}
                            </span>
                          </h6>
                        </div>
                        <hr />
                        <div className="row align-items-center">
                          <div className="col-md-6">
                            <div class="d-flex justify-content-between align-items-center">
                              <div class="btn-group">
                                <div className="bown-num ">
                                  <p className="m-0">
                                    {" "}
                                    <small style={{ whiteSpace: "nowrap" }}>
                                      {moment(Number(item.created_at)).format(
                                        "DD MMM YYYY, h:mm a"
                                      )}
                                    </small>{" "}
                                  </p>
                                </div>{" "}
                                <div className="bown-num"></div>
                              </div>
                             
                            </div>
                          </div>
                          {/* {item.is_expired == true ? (
                            " "
                          ) : ( */}
                           <div className="col-md-6">
                                {/* <button
                                  onClick={() => handleActivate(item?.post_id, item?.status)}
                                  style={{ float: "right" }}
                                  className="btn btn-danger"
                                >
                                  {item?.status == "Active" ? "Active" : "Deactive"}
                                </button> */}
                                <Link to={`/media/${item._id}/view`}>
                            <div className="text-end">
                              <button
                                onClick={() => handleConfirm(item._id)}
                                style={{ float: "right" }}
                                className="btn mt-2 btn-outline-dark"
                              >
                                Details
                              </button>
                            </div>
                          </Link>
                              </div>
                          {/* )} */}
                          {/* Remove modal */}
                          <Modal
                            show={showRemove}
                            onHide={() => setShowRemove(false)}
                            backdrop="static"
                            keyboard={false}
                            centered
                            scrollable

                            className="confirm-box-modal"
                          >
                            <Modal.Header>
                              <Modal.Title>
                                Remove
                              </Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                              <div className="my-3 text-center">
                                Do you want to Remove?
                              </div>
                            </Modal.Body>
                            <Modal.Footer>
                              <Button onClick={() => setShowRemove(false)} className="px-6 confirm-btn">
                                No
                              </Button>
                              <Button onClick={() => handleRemove(showRemove)} className="px-6 confirm-btn">
                                Yes
                              </Button>
                            </Modal.Footer>
                          </Modal>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              <div>
                {/* Modal for Reply */}
                <Modal
                  show={Reply}
                  onHide={handleCloseReply}
                  centered
                  scrollable
                >
                  <Modal.Header closeButton>
                    <Modal.Title>
                      <Link
                        to=""
                        style={{
                          textDecoration: "none",
                          color: "#000000",
                          cursor: "auto",
                        }}
                      >
                        Replies on story
                      </Link>
                    </Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    {getReply?.count == 0 ? <div className="fw-bolder d-flex justify-content-center">No Replies</div> : getReply?.replies?.map((item, index) => (
                      <>
                        <div className="image-name-box d-flex gap-2 align-items-start w-100" key={index}>
                          <div className="image-box">
                            <img
                              src={getUserProfileImage(item?.profile_pic)}
                              alt="ProfileImage"
                              class="modal-profile align-items-start"
                            />
                          </div>

                          <div className="name-box w-100">
                            <div className="d-flex align-items-center justify-content-between align-items-center">
                              <div>
                                <Link
                                  to={`/user/${item?.user_id}/1/1?type=posts`}
                                  className="Details_of_User"
                                >
                                  <p className="mb-0 profile-name">{item.full_name}</p>
                                </Link>
                              </div>
                              <div className="">
                                <p
                                  className="m-0"
                                  style={{
                                    fontSize: "12px",
                                    fontWeight: "bold",
                                  }}
                                >
                                  {moment(Number(item.created_at)).format("DD MMM YYYY, h:mm a")}
                                </p>
                              </div>
                            </div>
                            <p
                              className="m-0"
                              style={{
                                fontSize: "12px",
                              }}
                            >
                              {item.message}
                            </p>
                          </div>
                        </div>
                        <hr />
                      </>
                    ))}
                  </Modal.Body>
                </Modal>
              </div>
              <div>
                {/* Modal Views */}
                <Modal
                  show={Views}
                  onHide={handleCloseViews}
                  centered
                  scrollable
                >
                  <Modal.Header closeButton>
                    <Modal.Title>
                      <Link
                        to=""
                        style={{
                          textDecoration: "none",
                          color: "#000000",
                          cursor: "auto",
                        }}
                      >
                        Views on story
                      </Link>
                    </Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    {getView?.count == 0 ? <div className="fw-bolder d-flex justify-content-center">No Views</div> : getView?.views?.map((item, index) => (
                      <>
                        <div
                          class="tab-pane fade show active "
                          id="home"
                          role="tabpanel"
                          aria-labelledby="home-tab"
                        >
                          <div
                            className="modal-wrapper d-flex align-items-center  mx-2"
                            key={index}
                          >
                            <img
                              src={getUserProfileImage(item?.profile_pic)}
                              alt="ProfileImage"
                              class="modal-profile me-2"
                            />
                            <Link
                              to={`/user/${item?.user_id}/1/1?type=posts`}
                              className="Details_of_User"
                            >
                              <p className="mb-0 profile-name">
                                {item?.full_name
                                  ? item?.full_name
                                  : "No Views"}
                              </p>
                            </Link>
                          </div>
                        </div>
                        <hr />
                      </>
                    ))}
                  </Modal.Body>
                </Modal>
              </div>
              <PaginationLayout
                count={totalCount}
                data={storiesData}
                page={Number(param.page)}
                limit={Number(limit)}
                loading={loading}
                onPageChange={(val) => handlePagination(val)}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default ReportedStories;
